import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { LanguageRepository } from '@app-core/state/language.repository';
import { makeObjectWithNoNullValues } from '@app-shared/functions/helpers.functions';
import { CountryRepository } from 'src/app/entities/countries/state/country.repository';
import { CountriesFilterRepository } from 'src/app/entities/filters/countries/state/countries-filter.repository';
import { environment } from 'src/environments/environment';

export const countryAndLanguageInterceptor: HttpInterceptorFn = (req, next) => {
  const languageRepo = inject(LanguageRepository);
  const countryRepo = inject(CountryRepository);
  const countriesFilterRepo = inject(CountriesFilterRepository);

  if (req.url.startsWith(environment.apiUrl)) {
    // countries filter params
    const filteredCountriesIDs = countriesFilterRepo.getSelectedCountriesIDs();

    const params = makeObjectWithNoNullValues({
      regional_countries: JSON.stringify(
        filteredCountriesIDs.map(id => id.toString()),
      ),
      country: countryRepo.getActiveId()?.toString() || null,
      language:
        languageRepo
          .getLanguageByCode(languageRepo.getActiveLanguageCodeOrDefaultCode())
          ?.id?.toString() || null,
    });

    req = req.clone({
      setParams: params,
    });
  }

  return next(req);
};
